<template>
  <div class="container is-fluid">
      <div class="columns">
        <div class="column" style="font-family: Helvetica">
          <section id="about-anchor" ref="about-anchor" class="hero">
            <div class="hero-body">
              <p class="title has-text-white">Music</p>
              <p class="subtitle has-text-white">
                Music according to Viscuso
              <ul>
              <li><a href="http://www.facebook.com/album.php?aid=298015&id=668452176&l=1537743855http://www.facebook.com/album.php?aid=298015&id=668452176&l=1537743855" target="_blank">Photos</a></li>
              <li><a href="http://www.youtube.com/results?search_query=%22emanuele+viscuso+in+concert%22&aq=f" target="_blank">Listen Music</a></li>
              <li><a href="http://www.facebook.com/album.php?aid=301482&id=668452176&l=e92990539d" target="_blank">Articles</a></li>
              </ul>
              </p>
            </div>
          </section>
          <h2 class="abouttext">
            <h3></h3>
            <p>Emanuele Viscuso composes new-romantic music. <br/> <br/> 
            He plays the piano and has performed all over the world.
            Music for Viscuso is an element, which is primeval, and vital on which he bases his entire artistic experience.
              His designs are "designs of music", his sculpture is "solid music", and his ideal city is the "City of Music". 
              Viscuso is self-taught but is compositions and his musical interpretations are the highest level of expression. 
              One of his most memorable concert was held at the "Teatro delle Erbe" in Milan, Italy in 1989. 
              The concert was benefiting the populations of Armenia after the earthquake.  
              Viscuso has numerous concerts to his credit in Italy and abroad, but currently he is devoting more and more time to his commitments in other 
              artistic areas and to his social and cultural commitments.</p>
            <br/><br/>
            <p style="font-weight: bold;"> Viscuso e la musica</p>   <br/> <br/> 
            <p>Emanuele Viscuso compone musica neoromantica e si e' 
              esibito in concerti in tutto il mondo. <br/><br/> 
              Il suo strumento e' il pianoforte. 
              La musica e per Viscuso l'elemento primordiale e vitale.
              Su di essa si basa la sua intera esperienza artistica.
                I suoi disegni sono disegni di musica, le sue sculture sono musica solida, la sua citte ideale e la citte della musica. 
                Viscuso e autodidatta ma le sue composizioni e le sue interpretazioni pianistiche sono al miglior livello espressivo.
            Memorabile, fra gli altri, resta il suo concerto al "Teatro delle Erbe" tenuto a favore dei terremotati dell'Armenia (Milano 1989). 
            Viscuso ha numerosi concerti all'attivo in Italia ed all'estero, ma attualmente la sua attivite concertistica si e dovuta ridimensionare
            a causa dei sempre pie numerosi impegni negli altri settori artistici e nel suo impegno sociale.</p>
            <br/><br/><br/><br/>
          </h2>
        </div>
        <div class="column" style="min-height: 500px">
          <img
          class="bigimage"
            src="images/viscuso_concerto_press.jpg"
            alt="Emanuele Viscuso"
            align="left"
            style="margin: 50px 20px"
          /><br />
          <img
          class="midimage"
            v-prlx="{
              mobileMaxWidth: 500,
              speed: 0.5,
              fromBottom: false,
              preserveInitialPosition: true,
            }"
            src="images/piano2.jpg"
            alt="Emanuele Viscuso"
            align="left"
            contain
            style="margin: -100px 0px"
          />
          <img
          class="bigimage"
            src="images/piano1.jpg"
            alt="Emanuele Viscuso"
            align="right"
            contain
            style="margin: 10px -20px"
          /><br />
          
          
        </div>
        
      </div>
    </div>
</template>

<script>
export default {
  name: "Music",
  components: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
.container {
  background-color: #040303;
  background-attachment: fixed;
  background-size: cover;
  color: #fff;
}

.link {
  color: #9dc7de;
  transition: 0.3s color ease;

  &:hover {
    color: #e48353;
  }
}

a {
  color: #9dc7de;
  transition: 0.3s color ease;
}
a:hover {
  color: #e48353;
}
.bigimage {
  width: 80%;
}

.midimage {
  width: 50%;
}

.abouttext {
  font-family: "Helvetica";
  font-size: 1.8em;
  text-align: justify;
}

h1 {
  margin-top: 2rem;
  z-index: 10;
  position: absolute;
}
</style>
